import {
  AnantRightSvg,
  EnjoyRightSvg,
  GetShieldedRightSvg,
  LeaveRightSvg,
  TrueSecurityRightSvg,
  YourSarthiRightSvg,
} from "../../../components/WhatMakesSvg";
import anantImg from "../../../assets/images/what-makes/svg/anantLeft.svg";
import trueSecurityImg from "../../../assets/images/what-makes/svg/trueSecurityLeft.svg";
import yourSarthiImg from "../../../assets/images/what-makes/svg/yourSarthiLeft.svg";
import enjoyImg from "../../../assets/images/what-makes/svg/enjoyLeft.svg";
import getShieldedImg from "../../../assets/images/what-makes/svg/getShieldedLeft.svg";
import leaveImg from "../../../assets/images/what-makes/svg/leaveLeft.svg";

export const features = [
  {
    leftImage: anantImg,
    RightSvg: AnantRightSvg,
    title: "Anant Benefits*, Anant Care",
    description:
      "With Anant benefit get infinite Sum Insured for hospitalization due to Heart conditions, Cancer, Stroke and Organ/Bone Marrow Transplant where you need finances the most without impacting the savings and investments.",
  },
  {
    leftImage: trueSecurityImg,
    RightSvg: TrueSecurityRightSvg,
    title: "True Security with Tatkal Benefit*",
    description:
      "With Tatkal benefit get absolutely Zero Waiting Period ensuring you receive the care and coverage you need right from the start. No delays, just instant and complete assurance.",
  },
  {
    leftImage: yourSarthiImg,
    RightSvg: YourSarthiRightSvg,
    title: "Your Sarathi* in a True Sense",
    description:
      "With Sarathi, get your waiting period reduced to 30 days from the usual 36 months, even if you have Pre-Existing diseases such as Asthma, Diabetes, Dyslipidemia, Obesity, Hypertension.",
  },
  {
    leftImage: enjoyImg,
    RightSvg: EnjoyRightSvg,
    title: "Enjoy the Gullak Benefits",
    description:
      "Your Gullak balance grows by 100% each year with a guaranteed 15x bonus, safeguarding you against inflation and ensuring your coverage never runs out.",
  },
  {
    leftImage: getShieldedImg,
    RightSvg: GetShieldedRightSvg,
    title: "Get Shielded with Personal Accident Cover*",
    description:
      "Accidents can happen anytime, anywhere. Protect your family with accident cover and get a fixed benefit coverage up to `3 Cr",
  },
  {
    leftImage: leaveImg,
    RightSvg: LeaveRightSvg,
    title: "Leave Non-medical Expenses* on us",
    description:
      "Get complete coverage for non-medical items and durable medical equipment, including gloves, masks, and more. Because when we say complete health insurance policy, we mean it",
  },
];
